/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateActivityRequestSchema } from "./updateActivityRequestSchema.ts";
import { updateActivitySchema } from "./updateActivitySchema.ts";

export const callbackPluginUpdateMenuActivityCreateStatus200Schema = updateActivitySchema;

export const callbackPluginUpdateMenuActivityCreateResponseSchema = callbackPluginUpdateMenuActivityCreateStatus200Schema;

export const callbackPluginUpdateMenuActivityCreateDataSchemaJson = updateActivityRequestSchema;

export const callbackPluginUpdateMenuActivityCreateDataSchemaXml = updateActivityRequestSchema;

export const callbackPluginUpdateMenuActivityCreateDataSchema = z.union([
	callbackPluginUpdateMenuActivityCreateDataSchemaJson,
	callbackPluginUpdateMenuActivityCreateDataSchemaXml,
]);
